module.exports = __webpack_public_path__ + "static/media/logout.9306e5fc.svg";